import { hasInErrorReason } from "./helpers";

export const isOdsClaimInError = (claim) =>
    hasInErrorReason(
        claim?.claimStatus,
        claim?.derivedClaimStatusDesc,
        claim?.claimStatusReason,
        claim?.customClaimStatusReasonDesc
    );

export const isOdsLeaveInError = (leave) =>
    hasInErrorReason(
        leave?.leaveCloseReason,
        leave?.leaveReasonDesc,
        leave?.srcLeaveStatus,
        leave?.leaveStatus
    );

const removeInErrorFromEmployee = (employee) => {
    const claims = Array.isArray(employee?.claim) ? employee.claim : [];
    const leaves = Array.isArray(employee?.leave) ? employee.leave : [];
    const validClaims = claims.filter((claim) => !isOdsClaimInError(claim));
    const validLeaves = leaves.filter((leave) => !isOdsLeaveInError(leave));

    // Employees whose only claims/leaves were in error are hidden entirely.
    const hadRecords = claims.length + leaves.length > 0;
    if (hadRecords && validClaims.length + validLeaves.length === 0) {
        return null;
    }

    return { ...employee, claim: validClaims, leave: validLeaves };
};

export const removeInErrorOdsEmployeeRecords = (response) => {
    if (!Array.isArray(response?.EmployeeDetail)) {
        return response;
    }

    return {
        ...response,
        EmployeeDetail: response.EmployeeDetail.map(
            removeInErrorFromEmployee
        ).filter(Boolean),
    };
};
